import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'vodTemplates',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  editURL: routes.VOD_TEMPLATE_EDIT,
  emptyMessage: "You don't have VoD templates yet, click on the +new button to make a new one.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: true,
      canFilter: true,
      exactWidth: '80px',
      hidden: true
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of VoD template.',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'typeToFilter',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Type',
      helpText: 'Type of video job: Equirectangular, 360º, 180º, flat or control room.',
      errorText: '',
      default: 'no-filter',
      canOrder: true,
      canFilter: true,
      exactWidth: '200px',
      filterSelectOptions: [
        { name: 'Type filter...', value: 'no-filter' },
        { name: 'Equirectangular', value: 'globe' },
        { name: '180º', value: '180' },
        { name: 'Flat', value: 'flat' },
        { name: 'Control Room', value: 'croom' },
      ],
    },
    {
      attributeName: 'stereoModeTypeToFilter',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Stereo Mode',
      helpText: 'Stereo mode of VoD template.',
      errorText: '',
      default: 'no-filte',
      canOrder: true,
      canFilter: true,
      exactWidth: '200px',
      filterSelectOptions: [
        { name: 'Type filter...', value: 'no-filter' },
        { name: 'Mono', value: 'mono' },
        { name: 'Top Bottom', value: 'top bottom' },
        { name: 'Left Right', value: 'left right' },
      ],
    },
    {
      attributeName: 'created_at',
      label: 'Created At',
      type: FormInputTypes.TIMESTAMP,
      helpText: 'Date of VoD template creation.',
      canOrder: true,
      exactWidth: '250px',
    },
  ],
};